<template>
  <header class="header" :class="headerFormat()" v-if="routeLayout.isHeader" style="z-index: 20">
    <div class="inner">
      <div class="left" v-if="routeLayout.isBack">
        <button class="header-btn" @click="fnBack"><i class="ico-arrow-left"></i></button>
      </div>
      <h1 class="ttl">{{ routeLayout.titleName }}</h1>

      <!-- 홈 버튼: 홈 화면이 아닌 모든 페이지에서 노출 (260421 회의) -->
      <div class="right" v-if="!isHomePath" style="padding-left: 5px">
        <button class="header-btn" @click="fnPush" aria-label="홈"><i class="ico-fill-church"></i></button>
      </div>

      <!--<div class="right" v-if="routeLayout.isLike">-->
      <div
        class="right"
        v-if="false /* 중보기도 아멘 비활성화 260407 */ && well.userNo !== userData.userNo"
      >
        <button class="header-btn" @click="fnWellLike()">
          <i class="ico-fill-heart" :class="well.isLike ? 'on' : ''"></i>
        </button>
      </div>

      <div class="right" v-if="routeLayout.isExcel && isApp() && fnCheckIsMine()" style="padding-left: 5px">
        <button class="header-btn" @click="excelDownload()"><i class="ico-download"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isFuneralShare" style="padding-left: 5px">
        <button class="header-btn" @click="funeralShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div class="right" id="kakaotalk-sharing-btn" v-if="routeLayout.isFuneralKakaoShare" style="padding-left: 5px">
        <button class="header-btn" @click="funeralKakaoShare()"><i class="ico-kakao"></i></button>
      </div>
      <div class="right" v-if="routeLayout.isAnnouncementShare" style="padding-left: 5px">
        <button class="header-btn" @click="announcementShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isBusinessLike" style="padding-left: 5px">
        <button class="header-btn" @click="fnBusinessLike">
          <i class="ico-fill-heart" :class="business.isLike ? 'on' : ''"></i>
        </button>
      </div>

      <div class="right" v-if="routeLayout.isBusinessSubscribe" style="padding-left: 5px">
        <button class="header-btn subscribe-btn" @click="fnBusinessSubscribe" :title="business.isSubscribed ? '구독 중 — 마케팅 알림 수신' : '구독하기 — 마케팅 알림 받기'">
          <i
            class="subscribe-bell"
            :class="business.isSubscribed ? 'on' : ''"
            :style="{ '--bell-icon-url': `url(${bellIconUrl})` }"
          ></i>
        </button>
      </div>

      <div class="right" v-if="routeLayout.isBusinessShare && business.isShareWish !== false" style="padding-left: 5px">
        <button class="header-btn" @click="businessShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>
      <div class="right" id="kakaotalk-sharing-btn" v-if="routeLayout.isBusinessKakaoShare && business.isShareWish !== false" style="padding-left: 5px">
        <button class="header-btn" @click="businessKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isBusinessMarketingShare" style="padding-left: 5px">
        <button class="header-btn" @click="businessMarketingShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div
        class="right"
        id="kakaotalk-sharing-btn"
        v-if="routeLayout.isBusinessMarketingKakaoShare"
        style="padding-left: 5px"
      >
        <button class="header-btn" @click="businessMarketingKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isBusinessDonationShare" style="padding-left: 5px">
        <button class="header-btn" @click="businessDonationShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>
      <div
        class="right"
        id="kakaotalk-sharing-btn"
        v-if="routeLayout.isBusinessDonationKakaoShare"
        style="padding-left: 5px"
      >
        <button class="header-btn" @click="businessDonationKakaoShare()"><i class="ico-kakao"></i></button>
      </div>


      <div class="right" v-if="routeLayout.isBusinessJobShare" style="padding-left: 5px">
        <button class="header-btn" @click="businessJobShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div
        class="right"
        id="kakaotalk-sharing-btn"
        v-if="routeLayout.isBusinessJobKakaoShare"
        style="padding-left: 5px"
      >
        <button class="header-btn" @click="businessJobKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div
        class="right"
        id="kakaotalk-sharing-btn"
        v-if="routeLayout.isAnnouncementKakaoShare"
        style="padding-left: 5px"
      >
        <button class="header-btn" @click="announcementKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isMemorialShare" style="padding-left: 5px">
        <button class="header-btn" @click="memorialShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div class="right" id="kakaotalk-sharing-btn" v-if="routeLayout.isMemorialKakaoShare" style="padding-left: 5px">
        <button class="header-btn" @click="memorialKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isSmileShare" style="padding-left: 5px">
        <button class="header-btn" @click="smileShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div class="right" id="kakaotalk-sharing-btn" v-if="routeLayout.isSmileKakaoShare" style="padding-left: 5px">
        <button class="header-btn" @click="smileKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isInvitationShare" style="padding-left: 5px">
        <button class="header-btn" @click="invitationShare()"><i class="ico-hd-share-gr90"></i></button>
      </div>

      <div class="right" id="kakaotalk-sharing-btn" v-if="routeLayout.isInvitationKakaoShare" style="padding-left: 5px">
        <button class="header-btn" @click="invitationKakaoShare()"><i class="ico-kakao"></i></button>
      </div>

      <div class="right header-bell-wrap" v-if="routeLayout.isBell" style="padding-left: 10px">
        <button class="header-btn">
          <i class="ico-bell " :class="userData.isRead ? '' : 'essen'" @click="fnBell"></i>
          <!-- 260506: 메인 헤더와 동일하게 unreadCount 숫자 뱃지 노출 (99 초과 시 99+). -->
          <span v-if="unreadNotiCount > 0" class="header-bell-badge" aria-hidden="true" @click="fnBell">
            {{ unreadNotiCount > 99 ? '99+' : unreadNotiCount }}
          </span>
        </button>
      </div>
      <div class="right" v-if="routeLayout.isSetting" style="padding-left: 10px">
        <button class="header-btn"><i class="ico-setting" @click="fnSetting"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isPlus" style="padding-left: 10px">
        <button class="header-btn"><i class="ico-add-gray90" @click="router.push('/diary/form')"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isDelete" style="padding-left: 5px">
        <button class="header-btn"><i class="ico-trash" @click="fnDiaryDelete"></i></button>
      </div>

      <div class="right" v-if="routeLayout.isEdit" style="padding-left: 5px">
        <button class="header-btn">
          <i class="ico-pencil" @click="fnPushDiaryForm"></i>
        </button>
      </div>

      <!-- 햄버거 오픈: 260423 항상 맨 오른쪽에 고정 (다른 .right 블록들 이후에 렌더) -->
      <div class="right" v-if="!isHomePath" style="padding-left: 10px">
        <button
          class="header-btn"
          @click="openHamburger"
          aria-label="메뉴"
          style="display:inline-flex;align-items:center;justify-content:center;"
        >
          <span style="display:inline-flex;flex-direction:column;justify-content:center;gap:4px;width:20px;height:16px;">
            <span style="display:block;width:100%;height:2.5px;background:#222;border-radius:2px;"></span>
            <span style="display:block;width:100%;height:2.5px;background:#222;border-radius:2px;"></span>
            <span style="display:block;width:100%;height:2.5px;background:#222;border-radius:2px;"></span>
          </span>
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import store from '@/store';
import { fnShowIsAppModalDynamic, isApp, isEmpty } from '@/common/utils/Util';
import { modalList, show, showLoginModal, showTextModal } from '@/common/utils/ModalState';
import { announcementKakaoShare, announcementShare } from '@/common/service/share/announcementShare';
import { memorialKakaoShare, memorialShare } from '@/common/service/share/memorialShare';
import { funeralKakaoShare, funeralShare } from '@/common/service/share/funeralShare';
import {
  businessDonationKakaoShare,
  businessDonationShare,
  businessKakaoShare,
  businessLike,
  businessMarketingKakaoShare,
  businessMarketingShare,
  businessShare,
  businessJobKakaoShare, businessJobShare
} from '@/common/service/share/businessShare';
import { invitationKakaoShare, invitationShare, smileKakaoShare, smileShare } from '@/common/service/share/smileShare';
import bellIconUrl from '@/assets/static/images/ico-bell.svg';
import { CODE_ENV_LIST, NAV_URL, WELL_DYING_CODE } from '@/common/constants/ConstCode';

const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();

const { push } = useRouter();

const routeLayout = computed(() => store.getters['layout/getRouteLayout']);
const isHomePath = computed(() => route.path === NAV_URL().HOME);
const openHamburger = () => store.commit('layout/setIsHamburger', true);
const business = computed(() => store.getters['business/getDetail']);
const getModalComponent = computed(() => store.getters['layout/getModalComponents']);
const userData = computed(() => store.getters['user/getUserData']);
const well = computed(() => store.getters['welldying/getDetail']);
// 260506: 헤더 종 아이콘 우상단 숫자 뱃지 (Main.vue와 동일 소스).
const unreadNotiCount = computed(() => store.getters['notification/getUnreadCount'] || 0);


const isFormDirty = computed(() => store.getters['layout/getFormDirty']);


const fnBack = () => {
  console.log('isFormDirty', isFormDirty.value)
  if (route.path.includes('/business/my')) {
    proxy.$router.replace('/business');
    return;
  }
  // 260428: 배터리·설정(charge-hub)에서 뒤로가기는 간판 선택 페이지로 (메인으로 빠지는 버그 방지)
  // select → ChargeHub 진입이 router.replace라 history에 select가 없음 → go(-1)이 메인으로 빠짐
  if (route.name === 'signboard-charge-hub' || /^\/business\/signboard\/[^/]+\/charge$/.test(route.path)) {
    proxy.$router.replace({ path: '/business/signboard/select', query: { target: 'charge' } });
    return;
  }
  // 260626: 협업·상담·문의 제안(cooperation/send) 작성 중 뒤로가기 — 작성 글 유실 경고
  if (route.path.includes('/business/cooperation/send') && isFormDirty?.value) {
    show(modalList.CONFIRM, {
      contents: '지금 나가면 작성 중인 글이\n사라질 수도 있습니다.\n정말 나가시겠습니까?',
      doneText: '나가기',
      cancelText: '취소',
      doneCallback: () => {
        store.commit('layout/setFormDirty', false);
        router.go(-1);
      }
    });
    return;
  }
  if (
    (!route.path.includes('/more') &&
      (route.path.includes('/form/information') && isFormDirty?.value ||
        route.path.includes('/welldying/form') && isFormDirty?.value ||
        route.path.includes('/funeral/form') ||
        route.path.includes('/announcement/form') && isFormDirty?.value)) ||
    route.path.includes('/smile/event/form/info') && isFormDirty?.value ||
    route.path.includes('/smile/invitation/form/info') && isFormDirty?.value
  ) {
    show(modalList.CONFIRM, {
      contents: '정말 이동하시겠습니까? \n 완료 전 작성된 내용은 저장되지 않습니다.',
      doneText: '이동하기',
      cancelText: '취소',
      doneCallback: () => {
        if (!isEmpty(getModalComponent.value)) {
          store.dispatch('layout/removeAllModalComponent');
          store.commit('memorial/initAllStep');
          store.commit('smile/initForm');
          store.commit('invitation/initForm');
        }
        store.commit('welldying/setDetail', {})
        router.go(-1);
        // proxy.$store.commit('layout/resetRouteLayout');
      }
    });
    return;
  }
  if (window.history.length <= 1) {
    proxy.$router.replace('/');
  } else {
    proxy.$router.go(-1);
  }
};

const fnBusinessLike = () => {
  if (!isApp()) {
    const dynamicUrl = `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/link/dynamicLink/business/${business.value.businessNo}`;
    fnShowIsAppModalDynamic(dynamicUrl);
    return;
  }
  if (isEmpty(userData.value.userNo)) {
    showLoginModal(() => {
      push('/signin');
    });
    return;
  }
  // 260507: 좋아요는 마케팅 구독 기능 아님 (마케팅 구독은 별도 fnBusinessSubscribe).
  // 기존 confirm 모달 텍스트가 사용자에게 마케팅 동의로 오해를 줘서 제거.
  businessLike();
};

const fnBusinessSubscribe = async () => {
  if (isEmpty(userData.value.userNo)) {
    showLoginModal(() => {
      push('/signin');
    });
    return;
  }
  console.log('[subscribe] click — current state:', business.value.isSubscribed, 'businessNo:', business.value.businessNo);
  if (!business.value.isSubscribed) {
    show(modalList.MARKETING_SUBSCRIBE_MODAL, {
      fnSubscribe: async () => {
        const ok = await store.dispatch('business/subscribeBusiness', business.value.businessNo);
        console.log('[subscribe] POST result:', ok, 'isSubscribed now:', business.value.isSubscribed);
        showTextModal(ok ? '구독이 완료되었습니다.\n마케팅 알림을 받을 수 있습니다.' : '구독에 실패했습니다.', '확인', null, 'green');
      }
    });
  } else {
    show(modalList.CONFIRM, {
      contents: '구독을 해제하시겠습니까?\n더 이상 마케팅 알림을 받지 않습니다.',
      cancelText: '취소',
      doneText: '해제',
      rightInnerClass: 'green',
      doneCallback: async () => {
        const ok = await store.dispatch('business/unsubscribeBusiness', business.value.businessNo);
        console.log('[subscribe] DELETE result:', ok, 'isSubscribed now:', business.value.isSubscribed);
        showTextModal(ok ? '구독이 해제되었습니다.' : '해제에 실패했습니다.', '확인', null, 'green');
      }
    });
  }
};

const fnWellLike = async () => {
  if (isEmpty(userData.value.userNo)) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
  } else {
    await store.dispatch('welldying/like');
  }
};

const fnSetting = () => {
  if (isEmpty(userData.value.userNo)) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
  } else router.push('/more/setting');
};

const excelDownload = () => {
  const funeral = store.getters['funeral/getDetail'];
  store.dispatch('funeral/excelDownload', {
    funeralNo: funeral.funeralNo
  });
};

const fnBell = () => {
  if (isEmpty(userData.value.userNo)) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
  } else router.push('/more/notification');
};

const fnDiaryDelete = () => {
  show(modalList.CONFIRM, {
    contents: '삭제하시겠습니까?',
    doneText: '삭제',

    cancelText: '취소',
    doneCallback: async () => {
      let diary = store.getters['diary/getDetail'];
      await store.dispatch('diary/delete', diary.diaryNo);
      await router.push('/diary');
    }
  });
};

const headerFormat = () => {
  if (routeLayout.value.isGreen && routeLayout.value.isGlass) return 'glass green';
  else if (routeLayout.value.isGlass && !routeLayout.value.isGreen) return 'glass';
  else if (!routeLayout.value.isGlass && routeLayout.value.isGreen) return 'green';
  else if (routeLayout.value.isHeaderPrimary) return 'primary-dark';
  else return '';
};

const fnPush = () => {
  if (route.path.includes('/form')) {
    show(modalList.CONFIRM, {
      contents: '정말 이동하시겠습니까? \n 완료 전 작성된 내용은 저장되지 않습니다.',
      doneText: '이동하기',
      cancelText: '취소',
      doneCallback: () => {
        router.push('/intro');
      }
    });
  } else {
    router.push('/intro');
  }
};

const fnPushDiaryForm = () => {
  let diary = store.getters['diary/getDetail'];
  router.push(`/diary/form/${diary.diaryNo}`);
};

function fnCheckIsMine() {
  const userInfo = store.getters['user/getUserData'];
  return Number(userInfo.userNo) === Number(store.getters['funeral/getDetail'].userNo);
}
</script>

<style scoped>
.subscribe-bell {
  display: inline-block;
  width: 24px;
  height: 24px;
  -webkit-mask: var(--bell-icon-url) no-repeat center / contain;
  mask: var(--bell-icon-url) no-repeat center / contain;
  background-color: #BDBDBD;
  transition: background-color 0.15s;
}
.subscribe-bell.on {
  background-color: #FFA000;
}

/* 260506: 헤더 종 아이콘 미열람 알림 카운트 뱃지 — Main.vue와 동일 룩앤필 */
.header-bell-wrap {
  position: relative;
}

.header-bell-wrap .header-btn {
  position: relative;
  overflow: visible;
}

.header-bell-badge {
  position: absolute;
  top: -0.2rem;
  right: -0.4rem;
  min-width: 1.6rem;
  height: 1.6rem;
  padding: 0 0.4rem;
  border-radius: 0.8rem;
  background: #ff3b30;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.6rem;
  text-align: center;
  letter-spacing: -0.02em;
  box-shadow: 0 0 0 0.15rem #fff;
  cursor: pointer;
}
</style>
